import React from "react";
import { cn } from "@/lib/utils";
import { useTheme } from "next-themes";
import Reveal from "@/components/brams/Reveal";

export default function SectionHeader({ eyebrow, title, subtitle, align = "left" }) {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === "dark";

  return (
    <div className={cn("flex flex-col", align === "center" && "items-center text-center")}>
      <Reveal>
        <span
          data-testid="section-eyebrow"
          className={cn(
            "inline-flex items-center gap-2 text-[10px] md:text-[11px] uppercase tracking-[0.4em] font-medium",
            isDark ? "text-white/60" : "text-black/50"
          )}
        >
          <span className={cn("w-6 h-px", isDark ? "bg-white/40" : "bg-black/40")} />
          {eyebrow}
        </span>
      </Reveal>
      <Reveal delay={120}>
        <h2 className="mt-6 font-display font-semibold text-3xl sm:text-4xl md:text-5xl lg:text-6xl tracking-tighter leading-[1.05] max-w-3xl">
          {title}
        </h2>
      </Reveal>
      {subtitle && (
        <Reveal delay={220}>
          <p
            className={cn(
              "mt-6 text-base md:text-lg max-w-xl font-body font-light leading-relaxed",
              isDark ? "text-white/65" : "text-black/60"
            )}
          >
            {subtitle}
          </p>
        </Reveal>
      )}
    </div>
  );
}
